let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bmhAT")).then(() => parcelRequire('bZ81h'));